import { Reveal, SectionHeading } from "./shared";
import { EVIDENCE, IMAGES } from "../../data";

export default function Evidence() {
  return (
    <section id="evidence" className="relative py-28 md:py-40 bg-[#0c161e] border-y border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <SectionHeading
          chapter="02 // FRAGMENTED EVIDENCE"
          title={<>Three exhibits.<br />One chain.</>}
          kicker="Each exhibit is examined against the design basis, then reasoned against every other — surfacing the causal relationships that rule some failure modes out and point toward the root."
        />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {EVIDENCE.map((ex, i) => {
            const span = i === 0 ? "md:col-span-7" : i === 1 ? "md:col-span-5" : "md:col-span-12";
            const tall = i === 0;
            return (
              <Reveal key={ex.tag} delay={i * 0.08} className={span}>
                <article
                  data-testid={`evidence-${i}`}
                  className={`group relative border border-white/10 bg-[#152430] overflow-hidden h-full transition-colors duration-500 hover:border-[#b88457]/40 hover:shadow-[0_0_40px_rgba(184,132,87,0.08)] ${
                    i === 2 ? "md:flex" : ""
                  }`}
                >
                  <div className={`relative overflow-hidden ${i === 2 ? "md:w-1/2" : ""}`}>
                    <img
                      src={IMAGES[ex.img]}
                      alt={ex.title}
                      className={`w-full object-cover duotone group-hover:scale-105 transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] ${
                        tall ? "h-72 md:h-96" : i === 2 ? "h-64 md:h-full" : "h-72 md:h-96"
                      }`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#152430] via-transparent to-transparent" />
                    <div className="absolute top-4 left-4 font-mono-data text-[10px] tracking-[0.25em] text-black bg-[#b88457] px-2 py-1">
                      {ex.tag}
                    </div>
                    {/* corner brackets */}
                    <span className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#b88457]/50" />
                  </div>
                  <div className={`p-6 md:p-8 ${i === 2 ? "md:w-1/2 md:flex md:flex-col md:justify-center" : ""}`}>
                    <div className="font-mono-data text-[10px] tracking-[0.2em] text-zinc-500 mb-3">{ex.meta}</div>
                    <h3 className="font-display font-bold text-white text-xl md:text-2xl tracking-tight mb-3">
                      {ex.title}
                    </h3>
                    <p className="text-zinc-400 text-sm leading-relaxed mb-5">{ex.body}</p>
                    <div className="font-mono-data text-[11px] tracking-[0.15em] text-[#b88457] flex items-center gap-2 border-t border-white/10 pt-4">
                      <span className="w-1.5 h-1.5 bg-[#b88457]" />
                      {ex.conf}
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
